import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { AudioPlayer } from './AudioPlayer';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden py-8 lg:py-0" data-id="element-86">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-87">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-[#d4a5a5]/20 blur-[100px]" data-id="element-88" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[600px] h-[600px] rounded-full bg-[#9d4b6b]/10 blur-[120px]" data-id="element-89" />
      </div>

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-91">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#2d2d2d] leading-[1.1] mb-6 tracking-tight" data-id="element-92">
            EL DIVORCIO <span className="text-[#9d4b6b] italic" data-id="element-93">EMOCIONAL</span>
          </h1>

          <p className="text-xl md:text-2xl text-[#5a5a5a] mb-8 font-light leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-94">
            La guía práctica para reconectar con tu esposo cuando el “te amo” se
            volvió costumbre.
          </p>

          {/* Audio Player */}
          <div className="mb-8" data-id="element-95">
            <AudioPlayer data-id="element-96" />
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center" data-id="element-97">
            <CTAButton scrollToPurchase data-id="element-98">Comienza Tu Renacer Hoy</CTAButton>
          </div>

          {/* Trust badges */}
          <div className="grid grid-cols-3 gap-3 mt-6 max-w-md mx-auto" data-id="element-99">
            <div className="flex flex-col items-center text-center gap-1.5" data-id="element-100">
              <ShieldCheck className="w-6 h-6 text-[#9d4b6b]" data-id="element-101" />
              <span className="text-xs text-[#8b6f6f] font-medium leading-tight" data-id="element-102">
                Garantía de Satisfacción
              </span>
            </div>
            <div className="flex flex-col items-center text-center gap-1.5" data-id="element-103">
              <Zap className="w-6 h-6 text-[#9d4b6b]" data-id="element-104" />
              <span className="text-xs text-[#8b6f6f] font-medium leading-tight" data-id="element-105">
                Descarga Inmediata a tu correo
              </span>
            </div>
            <div className="flex flex-col items-center text-center gap-1.5" data-id="element-106">
              <Lock className="w-6 h-6 text-[#9d4b6b]" data-id="element-107" />
              <span className="text-xs text-[#8b6f6f] font-medium leading-tight" data-id="element-108">
                Pago Seguro en tu Compra
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        rotate: -2
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="relative flex justify-center lg:justify-end" data-id="element-109">
          <div className="relative z-10 w-[280px] md:w-[380px] lg:w-[450px] shadow-2xl shadow-[#9d4b6b]/30 rounded-lg overflow-hidden transform hover:scale-[1.02] transition-transform duration-500" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/qfVmSh5sWYSJ6KRRXesGMW/COVER_EL_DIVORCIO_EMOCIONAL_EBOOK.png" alt="Portada del libro El Divorcio Emocional" className="w-full h-auto object-cover" data-id="element-111" />
            {/* Glossy overlay effect */}
            <div className="absolute inset-0 bg-gradient-to-tr from-black/10 to-transparent pointer-events-none" data-id="element-112" />
          </div>

          {/* Decorative backdrop behind book */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] border border-[#9d4b6b]/20 rounded-full -z-10" data-id="element-113" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] h-[140%] border border-[#9d4b6b]/10 rounded-full -z-10" data-id="element-114" />
        </motion.div>
      </div>
    </section>;
}